import { ReactNode } from 'react';

import { STooltipContent } from './styled';

type ContentProps = {
  children: ReactNode;
};

export const Content = ({ children }: ContentProps) => <STooltipContent>{children}</STooltipContent>;
